import { render } from "./IndicatorProgress.vue?vue&type=template&id=3aae168a"
import script from "./IndicatorProgress.vue?vue&type=script&lang=js"
export * from "./IndicatorProgress.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__